import { Navigate, useNavigate, useParams } from "react-router-dom";
import {
  AddBusiness,
  AddConsent,
  ApplicationsToPay,
  CheckCertificate,
  LoginPage,
  MailLogs,
  PaymentFinish,
  ProcessApplication,
  ProfileEdit,
  ReportGenerator,
  SystemSettings,
  UserEdit,
  UserManagement,
  Applications,
  ApplicationsShipping,
  Businesses,
} from "./pages";
import { CheckCertificateEmpty } from "./pages/CheckCertificate/CheckCertificate";
import { ProtectedRoute } from "./ProtectedRoute";
import { useEffect } from "react";
import { LocalStorageKeyConstants } from "./constants";

function RedirectToCertificateCheckWrapper() {
  const { certificateId, certificatePIN } = useParams();
  return (
    <Navigate to={`/certificate/check/${certificateId}/${certificatePIN}`} />
  );
}

export const redirects = {
  RedirectToDefaultApplicationStep: () => (
    <Navigate to="/application/edit/1/00000000-0000-0000-0000-000000000000" />
  ),
  RedirectToDefaultUserEdit: () => (
    <Navigate to="/user/edit/00000000-0000-0000-0000-000000000000" />
  ),
  RedirectToMyApplications: () => <Navigate to="/application/list" />,
  RedirectToCertificateCheck: () => {
    const navigate = useNavigate();
    useEffect(() => {
      localStorage.removeItem(LocalStorageKeyConstants.REDIRECT_PATH);
      navigate("/certificate/check/0/0", { replace: true });
    }, [navigate]);

    return null;
  },
};

const VerifyRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.removeItem(LocalStorageKeyConstants.REDIRECT_PATH);
    navigate("/certificate/check/0/0", { replace: true });
  }, [navigate]);

  return null;
};

export const routes = {
  loginLayout: [
    { path: "/login", element: <LoginPage mode="login" /> },
    { path: "/logout", element: <LoginPage mode="logout" /> },
    { path: "/register", element: <LoginPage mode="register" /> },
    {
      path: "/register/success/:e",
      element: <LoginPage mode="register-success" />,
    },
    {
      path: "/register/failure",
      element: <LoginPage mode="register-failure" />,
    },
    {
      path: "/register/activate/:userId",
      element: <LoginPage mode="activate" />,
    },
  ],

  mainLayout: [
    {
      path: "/",
      element: (
        <ProtectedRoute>
          <redirects.RedirectToMyApplications />
        </ProtectedRoute>
      ),
    },
    {
      path: "/certificate/internalcheck",
      element: (
        <ProtectedRoute>
          <CheckCertificateEmpty />
        </ProtectedRoute>
      ),
    },
    {
      path: "/certificate/internalcheck/:certificateId/:certificatePIN",
      element: (
        <ProtectedRoute>
          <CheckCertificate mode="embedded" />
        </ProtectedRoute>
      ),
    },
    {
      path: "/application/add",
      element: (
        <ProtectedRoute>
          <redirects.RedirectToDefaultApplicationStep />
        </ProtectedRoute>
      ),
    },
    {
      path: "/application/edit/:step/:id",
      element: (
        <ProtectedRoute>
          <ProcessApplication />
        </ProtectedRoute>
      ),
    },
    {
      path: "/application/list",
      element: (
        <ProtectedRoute>
          <Applications />
        </ProtectedRoute>
      ),
    },
    {
      path: "/application/toPay",
      element: (
        <ProtectedRoute>
          <ApplicationsToPay />
        </ProtectedRoute>
      ),
    },
    {
      path: "/settings",
      element: (
        <ProtectedRoute>
          <SystemSettings />
        </ProtectedRoute>
      ),
    },
    {
      path: "/application/shipping",
      element: (
        <ProtectedRoute>
          <ApplicationsShipping />
        </ProtectedRoute>
      ),
    },
    {
      path: "/application/paymentCompleted/:applicationId",
      element: (
        <ProtectedRoute>
          <PaymentFinish />
        </ProtectedRoute>
      ),
    },
    {
      path: "/account/consents/add/:consentType",
      element: (
        <ProtectedRoute>
          <AddConsent />
        </ProtectedRoute>
      ),
    },
    {
      path: "/business/add",
      element: (
        <ProtectedRoute>
          <AddBusiness />
        </ProtectedRoute>
      ),
    },
    {
      path: "/business/list",
      element: (
        <ProtectedRoute>
          <Businesses />
        </ProtectedRoute>
      ),
    },
    {
      path: "/user/add",
      element: (
        <ProtectedRoute>
          <redirects.RedirectToDefaultUserEdit />
        </ProtectedRoute>
      ),
    },
    {
      path: "/user/edit/:id",
      element: (
        <ProtectedRoute>
          <UserEdit />
        </ProtectedRoute>
      ),
    },
    {
      path: "/user/list",
      element: (
        <ProtectedRoute>
          <UserManagement />
        </ProtectedRoute>
      ),
    },
    {
      path: "/user/profile",
      element: (
        <ProtectedRoute>
          <ProfileEdit />
        </ProtectedRoute>
      ),
    },
    {
      path: "/preview",
      element: (
        <ProtectedRoute>
          <redirects.RedirectToCertificateCheck />
        </ProtectedRoute>
      ),
    },
    {
      path: "/report",
      element: (
        <ProtectedRoute>
          <ReportGenerator />
        </ProtectedRoute>
      ),
    },
    {
      path: "/maillogs",
      element: (
        <ProtectedRoute>
          <MailLogs />
        </ProtectedRoute>
      ),
    },
  ],

  noSidebarLayout: [
    {
      path: "/verify",
      element: <VerifyRedirect />,
    },
    {
      path: "/preview/:certificateId/:certificatePIN",
      element: <RedirectToCertificateCheckWrapper />,
    },
    {
      path: "/certificate/check/:certificateId/:certificatePIN",
      element: <CheckCertificate mode="external" />,
    },
  ],
};
